import { AddProductDialog } from "@/components/interface/AddProductDialog";
import { DeleteProductDialog } from "@/components/interface/DeleteProductDialog";
import { CartDialog } from "./CartDialog";
import { RestockDialog } from "./dialogs/RestockDialog";
import { ReturnDialog } from "./dialogs/ReturnDialog";
import { LossDialog } from "@/components/interface/LossDialog";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface StockDialogsContainerProps {
  isAddProductDialogOpen: boolean;
  setIsAddProductDialogOpen: (open: boolean) => void;
  isDeleteProductDialogOpen: boolean;
  setIsDeleteProductDialogOpen: (open: boolean) => void;
  isCartDialogOpen: boolean;
  setIsCartDialogOpen: (open: boolean) => void;
  isRestockDialogOpen: boolean;
  setIsRestockDialogOpen: (open: boolean) => void;
  isReturnDialogOpen: boolean;
  setIsReturnDialogOpen: (open: boolean) => void;
  isLossDialogOpen: boolean;
  setIsLossDialogOpen: (open: boolean) => void;
  selectedItem: any;
  stockItems: any[];
  handleAddProduct: (product: any) => void;
  handleDeleteProduct: (productId: string) => void;
  refetch: () => void;
}

export const StockDialogsContainer = ({
  isAddProductDialogOpen,
  setIsAddProductDialogOpen,
  isDeleteProductDialogOpen,
  setIsDeleteProductDialogOpen,
  isCartDialogOpen,
  setIsCartDialogOpen,
  isRestockDialogOpen,
  setIsRestockDialogOpen,
  isReturnDialogOpen,
  setIsReturnDialogOpen,
  isLossDialogOpen,
  setIsLossDialogOpen,
  selectedItem,
  stockItems,
  handleAddProduct,
  handleDeleteProduct,
  refetch,
}: StockDialogsContainerProps) => {
  const [lossQuantity, setLossQuantity] = useState("");

  const handleLossConfirm = async (quantity: number, selectedProductId: string) => {
    try {
      const selectedProduct = stockItems.find(item => item.id === selectedProductId);
      if (!selectedProduct) {
        toast.error("Produit non trouvé");
        return;
      }

      const { error: updateError } = await supabase
        .from('stock_items')
        .update({ 
          quantity: selectedProduct.quantity - quantity 
        })
        .eq('id', selectedProductId);

      if (updateError) throw updateError;

      const { error: lossError } = await supabase
        .from('stock_losses')
        .insert({
          stock_item_id: selectedProductId,
          quantity,
        });

      if (lossError) throw lossError;

      toast.success("Perte enregistrée avec succès");
      setIsLossDialogOpen(false);
      setLossQuantity("");
      refetch();
    } catch (error: any) {
      console.error("Erreur lors de l'enregistrement de la perte:", error);
      toast.error(error.message || "Erreur lors de l'enregistrement de la perte");
    }
  };

  return (
    <>
      <AddProductDialog
        isOpen={isAddProductDialogOpen}
        onOpenChange={setIsAddProductDialogOpen}
        onSubmit={handleAddProduct}
      />

      <DeleteProductDialog
        open={isDeleteProductDialogOpen}
        onOpenChange={setIsDeleteProductDialogOpen}
        stockItems={stockItems}
        onConfirmDelete={handleDeleteProduct}
      />

      <CartDialog
        open={isCartDialogOpen}
        onOpenChange={setIsCartDialogOpen}
        refetch={refetch}
      />

      {isRestockDialogOpen && selectedItem && (
        <RestockDialog
          open={isRestockDialogOpen}
          onOpenChange={setIsRestockDialogOpen}
          selectedItem={selectedItem}
          refetch={refetch}
        />
      )}

      {isReturnDialogOpen && selectedItem && (
        <ReturnDialog
          open={isReturnDialogOpen}
          onOpenChange={setIsReturnDialogOpen}
          selectedItem={selectedItem}
          refetch={refetch}
        />
      )}

      {isLossDialogOpen && (
        <LossDialog
          open={isLossDialogOpen}
          onOpenChange={setIsLossDialogOpen}
          onQuantityChange={setLossQuantity}
          onConfirm={handleLossConfirm}
          lossQuantity={lossQuantity}
          stockItems={stockItems}
        />
      )}
    </>
  );
};